// extracted by mini-css-extract-plugin
export default {"swatch":"ColorInput_swatch__75via","popover":"ColorInput_popover__LOKSU","popover2":"ColorInput_popover2__cpu63","cover":"ColorInput_cover__o8qKo"};